// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"8a50f871","79":"86087139","123":"a926ff22","196":"01ea33ff","349":"ac6f50c3","381":"e91798a6","413":"65c5fa95","451":"5476cdf3","631":"f99221fd","836":"081931af","844":"f765d289","889":"475f765c","899":"17f6f279"}[chunkId] + ".js";
};